module.exports = __webpack_public_path__ + "static/skn-landscape-b8edac097b989bd7deef3ee9adc40136.jpg";